import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

export interface LinkedInPostResponse {
  query: string;
}

export interface ScheduleLinkedInRequest {
  post: string;
  img_urls: string[];
  erase_img_after_publish: boolean;
  scheduled_at: string;
  id: number;
}

export interface UpdateLinkedInRequest {
  post: string;
  img_urls: string[];
  erase_img_after_publish: boolean;
  scheduled_at: string;
}

export interface LinkedInAuthResponse {
  url: string;
}

export interface LinkedInAuthCompleteResponse {
  success: boolean;
  message: string;
}
export interface LinkedInPostPublish {
  post: string;
  img_urls: string[];
  id: number;
}

interface PostLinkedInPayload {
  id: string;
  target_handle: string;
}

interface ScheduleLinkedInPayload {
  post: string;
  img_urls: string[];
  scheduled_at: string;
  erase_img_after_publish: boolean;
  id?: string;
  target_handle?: string;
}

interface ConvertToPlainTextPayload {
  content: string;
}

export const linkedInService = {
  // LinkedIn Authentication
  getAuthUrl: async (): Promise<APIResponse<LinkedInAuthResponse>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/social-media/linkedin/auth/login'
    );
    return response.data;
  },

  // LinkedIn Callback
  handleCallback: async (
    state: string, // required
    code: string, // required
    error?: string, // optional
    error_description?: string // optional
  ): Promise<APIResponse<LinkedInAuthResponse>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/social-media/linkedin/callback`,
      {
        params: {
          state,
          code,
          error,
          error_description,
        },
      }
    );
    return response.data;
  },

  // Complete LinkedIn Authentication
  completeAuth: async ({
    linkedin_access_token,

    linkedin_social_user_id,
  }: {
    linkedin_access_token: string;
    linkedin_social_user_id: string;

  }
  ): Promise<APIResponse<LinkedInAuthCompleteResponse>> => {
    const response = await axiosInstance.private.put(
      '/api/v1/social-media/linkedin/auth/complete',
      {
        linkedin_access_token,
        linkedin_social_user_id
      }
    );
    return response.data;
  },

  // Post LinkedInPost
  postLinkedInPost: async (
    payload: PostLinkedInPayload,
  ): Promise<APIResponse<LinkedInPostResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/linkedin/publish',
      payload,
      
    );
    return response.data;
  },

  // Schedule LinkedInPost
  scheduleLinkedInPost: async (
    payload: ScheduleLinkedInPayload,
  ): Promise<APIResponse<LinkedInPostResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/social-media/linkedin/schedule',
      payload,
    );
    return response.data;
  },

  // Get All LinkedinPost
  getAllLinkedInPost: async (
    access_token: string
  ): Promise<APIResponse<LinkedInPostResponse[]>> => {
    const response = await axiosInstance.private.get(
      '/api/v1/social-media/linkedin/posts',
      {
        headers: {
          Cookie: `access_token=${access_token}`,
        },
      }
    );
    return response.data;
  },

  // Delete LinkedInPost
  deleteLinkedInPost: async (
    id: number,
    access_token: string
  ): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/social-media/linkedin/posts/${id}`,
      {
        headers: {
          Cookie: `access_token=${access_token}`,
        },
      }
    );
    return response.data;
  },
  // Update LinkedIn
  updateLinkedInPost: async (
    postId: number,
    data: UpdateLinkedInRequest
  ): Promise<APIResponse<LinkedInPostResponse>> => {
    const response = await axiosInstance.private.put(
      `/api/v1/social-media/linkedin/posts/${postId}`,
      { data },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  // convert to plain text 
  convertToPlainText: async (
    {content}: {content: string}
  ): Promise<APIResponse<{plain_text: string}>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/convert/plain',
      {
        context: content,
      }
    );
    return response.data;
  },
};

export default linkedInService;
